import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.414 6l4.293-4.293A.999.999 0 1010.293.293L6 4.586 1.707.293A.999.999 0 10.293 1.707L4.586 6 .293 10.293a.999.999 0 101.414 1.414L6 7.414l4.293 4.293a.999.999 0 101.414-1.414L7.414 6z" fill="#666" /></svg>);